export enum ModalReferencesEnumeration {
  CANCEL_PROCESS = 'CANCEL_PROCESS',
  DROP_PROCESS = 'DROP_PROCESS',
  ERROR_CANCEL_PROCESS = 'ERROR_CANCEL',
  KYC_ACCOUNT_CHECK = 'KYC_ACCOUNT_CHECK',
  KYC_BIZUM = 'KYC_BIZUM',
  KYC_VIDEOCALL = 'KYC_VIDEOCALL',
  POI_TGSS = 'POI_TGSS',
  POI_OPENBANKING = 'POI_OPENBANKING',
  PROOF_IDENTITY = 'PROOF_IDENTITY',
  PROOF_OF_RESIDENCE = 'PROOF_OF_RESIDENCE',
}
